module.exports = __webpack_public_path__ + "img/Saint Helena.6b93614f.svg";